import React, { Component } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import TextField from "@material-ui/core/TextField";
import { Calendar } from "primereact/calendar";
import { ContractorTopSellRptAction } from "../../actions";
import { connect } from "react-redux";
import tableRequest from "../../models/tableRequest.js";
import { Toast } from "primereact/toast";
import { CSVLink } from "react-csv";
import Loader from "../../templates/Loader.js";
import { Dropdown } from "bootstrap";
// import Dropdown from 'react-bootstrap/Dropdown';
class ContractorTopSellRpt extends Component {
  constructor(props) {
    super(props);
    this.tblResponse = new tableRequest();
    this.onPage = this.onPage.bind(this);
    this.onSort = this.onSort.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.FilterData = this.FilterData.bind(this);
    this.searchFilter = this.searchFilter.bind(this);
    this.state = {
      loading: false,
      FromDate: new Date(),
      ToDate: new Date(),
      first: 0,
      headers: [
        {
          key: "ProductName",
          label: "Product Name",
        },
        {
          key: "SeqNo",
          label: "SeqNo",
        },
        {
          key: "UserCity",

          label: "User City",
        },
      ],
      rows: 5,
      totalRecords: 0,
      globalFilter: null,
      visible: false,
      sortOrder: "",
      selectedOption: "", // To track the selected dropdown option
      searchValues: {}, // To store search values for each option
    };
  }
  componentDidMount() {
    const date = new Date();
    date.setHours(0, 0, 0, 0);
    date.setDate(date.getDate() - 7); // Default to 7 days ago
    const today = new Date();
    this.tblResponse.FromDate = date.toISOString().split("T")[0];
    this.tblResponse.ToDate = today.toISOString().split("T")[0];
    this.tblResponse.SortColumn = "ScanCount";
    this.setState({
      FromDate: date,
      ToDate: today,
    });
    this.fetchData();
  }

  fetchData() {
    this.props.fetchApi(this.tblResponse);
    this.props.exportingData(this.tblResponse);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.mappingList !== this.props.mappingList) {
      // this.props.myProp has a different value
      const e = this.props.mappingList;
      if (e && e.length > 0) {
        this.setState({
          totalRecords: e[0].TotalRows,
        });
      } else {
        this.setState({
          totalRecords: 0, // No data found
        });
      }
    }
  }

  handleActionClick = (e) => {
    e.preventDefault(); // Prevent dropdown from closing
    this.setState((prevState) => ({
      showSearch: !prevState.showSearch, // Toggle the search box visibility
    }));
  };

  handleOptionChange = (event) => {
    const selectedOption = event.target.value;
    this.tblResponse.SearchColumn = event.target.value;
    //this.tblResponse.ToDate = this.state.ToDate.toLocaleDateString();
    // this.props.exportingData(this.tblResponse);
    // this.props.fetchApi(this.tblResponse);
    // this.tblResponse.DealerId = this.state.selectedDealer; // Add dealer filter
    if (selectedOption.trim() === "") {
      // Reset data to "All Data"
      this.tblResponse.SearchColumn = ""; // Clear the search column
      this.tblResponse.SearchValue = ""; // Clear the search value
      this.tblResponse.PageSize = this.state.rows; // Reset pagination size
      this.tblResponse.First = 0; // Reset the first record index
      this.props.fetchApi(this.tblResponse); // Fetch all data
      this.props.exportingData(this.tblResponse); // Update export data
    }
    this.setState({
      selectedOption: selectedOption,
      searchValues: { ...this.state.searchValues, [selectedOption]: "" },
    });
  };

  //Handle Search Input Change
  handleSearchChange = (event) => {
    this.tblResponse.SearchValue = event.target.value;
    // this.tblResponse.ToDate = this.state.ToDate.toLocaleDateString();
    this.props.exportingData(this.tblResponse);
    this.props.fetchApi(this.tblResponse);
    this.tblResponse.DealerId = this.state.selectedDealer; // Add dealer filter
    const { selectedOption, searchValues } = this.state;
    this.setState({
      searchValues: {
        ...searchValues,
        [selectedOption]: event.target.value,
      },
    });
  };
  GetMapping() {
    let ToDt = new Date();
    let FrmDt = new Date();
    FrmDt.setDate(ToDt.getDate() - 7);
    const myFmDt = this.getCurrentDateYYYYMMDD(FrmDt);
    const myToDt = this.getCurrentDateYYYYMMDD(ToDt);
    this.tblResponse.FromDate = myFmDt;
    this.tblResponse.ToDate = myToDt;
    this.props.fetchApi(this.tblResponse);
    this.props.exportingData(this.tblResponse);
  }
  FilterData() {
    this.tblResponse.FromDate = this.getCurrentDateYYYYMMDD(
      this.state.FromDate
    );
    this.tblResponse.ToDate = this.getCurrentDateYYYYMMDD(this.state.ToDate);
    this.props.exportingData(this.tblResponse);
    this.props.fetchApi(this.tblResponse);
  }
  getCurrentDateYYYYMMDD(dt) {
    var dd = String(dt.getDate()).padStart(2, "0");
    var mm = String(dt.getMonth() + 1).padStart(2, "0");
    var yyyy = dt.getFullYear();
    return yyyy + "-" + mm + "-" + dd; // YYYY-MM-DD format
  }
  handleChange(event) {
    const { name, value } = event.target;
    switch (name) {
      case "FromDate":
        if (value === null || !(value instanceof Date)) {
          this.formIsValid = false;
          this.toast.show({
            severity: "error",
            summary: "Error Message",
            detail: "Please select from date.",
            life: 3000,
          });
          return;
        } else if (
          this.state.ToDate instanceof Date &&
          Date.parse(value) > Date.parse(this.state.ToDate)
        ) {
          this.formIsValid = false;
          this.toast.show({
            severity: "error",
            summary: "Error Message",
            detail: "From date must be less than or equal to to date.",
            life: 3000,
          });
          return;
        }
        break;
      case "ToDate":
        if (value === null || !(value instanceof Date)) {
          this.formIsValid = false;
          this.toast.show({
            severity: "error",
            summary: "Error Message",
            detail: "Please select to date.",
            life: 3000,
          });
          return;
        } else if (
          this.state.FromDate instanceof Date &&
          Date.parse(value) < Date.parse(this.state.FromDate)
        ) {
          this.formIsValid = false;
          this.toast.show({
            severity: "error",
            summary: "Error Message",
            detail: "To date must be greater than or equal to from date.",
            life: 3000,
          });
          return;
        }
        break;
      default:
        break;
    }
    this.setState({ [name]: value });
  }
  //to lazy load
  getLazyLoadingValues(event) {
    this.tblResponse.PageSize = event.rows;
    this.tblResponse.First = event.first + 1;
    this.tblResponse.IsActive = true;
    this.tblResponse.SearchValue =
      event.globalFilter || this.tblResponse.SearchValue;
    this.tblResponse.SortOrder = event.sortOrder === 1 ? "ASC" : "DESC";
    this.tblResponse.FromDate = this.state.FromDate.toLocaleDateString();
    this.tblResponse.ToDate = this.state.ToDate.toLocaleDateString();
  }
  onPage(event) {
    this.props.loadingData(true);
    //imitate delay of a backend call
    setTimeout(() => {
      // this.getLazyLoadingValues(event);
      // this.props.fetchApi(this.tblResponse);
      // this.props.exportingData(this.tblResponse);
      // Update tblResponse with pagination data
      this.tblResponse.PageSize = event.rows; // Number of rows per page
      this.tblResponse.First = event.first + 1; // Starting record index (1-based)
      this.tblResponse.SortOrder = this.state.sortOrder === 1 ? "ASC" : "DESC"; // Sorting order
      this.tblResponse.SearchValue =
        this.state.globalFilter || this.tblResponse.SearchValue; // Search value
      // Trigger API calls with updated tblResponse
      this.props.fetchApi(this.tblResponse);
      this.props.exportingData(this.tblResponse);
      this.setState({ rows: event.rows, first: event.first });
    }, 250);
  }
  //to search
  searchFilter(e) {
    const searchValue = e.target.value.toLowerCase();
    this.setState({ globalFilter: searchValue });
    this.tblResponse.SearchValue = searchValue;
    this.props.fetchApi({ ...this.tblResponse, SearchValue: searchValue });
    this.props.exportingData(this.tblResponse);
    // this.setState({ globalFilter: searchValue });
  }
  //to sort
  onSort(event) {
    this.props.loadingData(true);
    this.setState({ sortOrder: this.state.sortOrder === 1 ? 2 : 1 });
    const sortField =
      event.multiSortMeta[0].field === "" ? "" : event.multiSortMeta[0].field;
    this.tblResponse.SortColumn = sortField ? sortField : "";
    this.tblResponse.SortOrder = this.state.sortOrder === 1 ? "DESC" : "ASC"; //this.state.sortOrder === 1 ? 'DESC' : 'ASC';
    this.props.fetchApi(this.tblResponse);
    this.props.exportingData(this.tblResponse);
  }
  render() {
    const { selectedOption, searchValues } = this.state;
    return (
      <div className="datatable-filter-demo">
        <Toast ref={(el) => (this.toast = el)} />
        <Loader loader={this.props.loading} />
        <div className="row mb-3">
          {/* Dealer Wise Report Heading */}
          <div className="col-md-3 d-flex master_headhingcol align-items-center">
            <h4>Contractor-Wise Top Scanning Product</h4>
          </div>
          {/* Calendar, Submit, Export, Dropdown, and Search in one line */}
          <div className="col-md-9 d-flex align-items-center justify-content-between">
            {/* From Date Calendar */}
            <div className="d-flex align-items-center mr-3">
              <Calendar
                placeholder="From Date"
                name="FromDate"
                showIcon="true"
                value={this.state.FromDate}
                onChange={this.handleChange}
              />
            </div>

            {/* To Date Calendar */}
            <div className="d-flex align-items-center mr-3">
              <Calendar
                placeholder="To Date"
                name="ToDate"
                showIcon="true"
                value={this.state.ToDate}
                onChange={this.handleChange}
              />
            </div>

            {/* Submit Button */}
            <div>
              <button
                type="button"
                onClick={this.FilterData}
                className="btn btn-primary p-2 ml-3"
              >
                Submit
              </button>
            </div>

            {/* Export Button */}
            <div>
              <CSVLink
                data={this.props.List}
                headers={this.state.headers}
                filename={"Contractor Top Sell.csv"}
                target="_blank"
              >
                <button className="btn btn-success p-2 mr-2">Export</button>
              </CSVLink>
            </div>

            {/* Dropdown */}
            {/* <div>
                            <select
                                className="form-control"
                                style={{ height: "40px", borderRadius: "4px" }}
                                onChange={this.handleOptionChange}
                                size="small"
                            >
                                <option value=" ">All Data</option>
                                <option value="InvoiceNo">Contractor Name</option>
                                <option value="ProductName">Product Name</option>
                                <option value="DealerName"> Mobile Number</option>
                            </select>
                        </div> */}
            {/* Search Input */}
            {selectedOption && selectedOption !== " " && (
              <div className="d-flex align-items-center ml-3">
                <label htmlFor="searchInput" style={{ marginRight: "10px" }}>
                  {/* Search By {selectedOption}: */}
                </label>
                <input
                  id="searchInput"
                  type="text"
                  className="form-control"
                  value={searchValues[selectedOption] || ""}
                  onChange={this.handleSearchChange}
                  placeholder={`Enter ${selectedOption}`}
                  style={{
                    height: "40px",
                    borderRadius: "4px",
                    width: "200px",
                    alignItems: "center",
                  }}
                />
              </div>
            )}
          </div>
        </div>
        <div className="card">
          <DataTable
            value={this.props.mappingList}
            loading={this.props.loading}
            scrollable
            responsive={true}
            globalFilter={this.state.globalFilter}
            emptyMessage="No Data found."
            sortMode="multiple"
            paginator={true}
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
            rows={this.state.rows}
            style={{ width: "100%" }}
            rowsPerPageOptions={[
              5,
              10,
              100,
              200,
              parseInt(this.state.totalRecords),
            ]}
            totalRecords={this.state.totalRecords}
            lazy={true}
            first={this.state.first}
            onPage={this.onPage}
            onSort={this.onSort}
            ref={(el) => {
              this.dt = el;
            }}
          >
            <Column
              field="UserName"
              disabled
              header="Contractor Name"
              sortable
            ></Column>
            <Column
              field="UserCity"
              disable
              header="Contractor City"
              sortable
            ></Column>
            <Column
              field="ProductName"
              disabled
              header="Product Name"
              sortable
            ></Column>
            <Column
              field="CategoryName"
              disabled
              header="Category Name"
              sortable
            ></Column>            
            <Column
              field="ScanCount"
              disabled
              header="Scan Count"
              sortable
            ></Column>
          </DataTable>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    mappingList: state.ContractorTopSellRpt.items,
    List:
      state.ContractorTopSellRpt.exportitems == undefined
        ? []
        : state.ContractorTopSellRpt.exportitems,
    loading: state.ContractorTopSellRpt.loading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchApi: (obj) => {
      dispatch(ContractorTopSellRptAction.getAll(obj));
    },
    loadingData: (isLoding) =>
      dispatch(ContractorTopSellRptAction.loadingData(isLoding)),
    exportingData: (obj) =>
      dispatch(ContractorTopSellRptAction.exportData(obj)),
    exportingData: (obj) => console.log("Exporting data with obj", obj),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ContractorTopSellRpt);
